import { combineReducers, configureStore } from '@reduxjs/toolkit'

import userReducer from './reducers/UserReducer/UserSlice'
import authReducer from './reducers/AuthReducer/AuthSlice'

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
})

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    devTools: true,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  })
}

export type RootState = ReturnType<typeof rootReducer>

export type AppStore = ReturnType<typeof setupStore>

export type AppDispatch = AppStore['dispatch']
